<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/164PvJF/tc-custom/9781466863132.jpg?1731055857030" alt="This image is the cover for the book Lethal Lolita"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lethal Lolita
      </h1>
      <p class="bookDescription body article font2">
        <b>The inside account of one of the 1990s’ most sensational true crime scandals: teenaged Amy Fisher’s shocking affair with the married Joey Buttafuoco.</b><br/><br/><i>Her father called her his little princess . . .</i><br/><br/>The adored only child of affluent parents who placed the world at her feet, Amy Fisher had a glowing future. But she yearned for excitement, for the dark thrill of danger.<br/><br/><i>Her friends called her a mysterious loner . . .</i><br/><br/>While her classmates happily planned dates for the prom, seventeen-year-old Amy Fisher appalled them with tales of her wild sexual escapades, of her steamy, obsessive alleged affair with a married man—of a wife she wanted out of the picture.<br/><br/><i>Police called her a call girl and a killer . . .</i><br/><br/>But it wasn’t until Amy was arrested for attempting to slay unsuspecting Mary Jo Buttafuoco in cold blood in front of her own home, that police and reporters uncovered stories that included a sinister hidden world of secret call girl rings, attempts to hire hitmen with payment in sex—and a beeper still nestled in her purse on which clients could page her with personal codes.<br/><br/>Veteran <i>People</i> reporter Maria Eftimiades has covered the case in <i>Lethal Lolita</i>—and in this riveting book reveals a story even more shocking than the sensational headlines that captured the attention of the nation, and turned an all-American town inside out.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maria Eftimiades
      </h2>
      
      <p class="authorDescription body article"><P>Maria Eftimiades is a journalist and the author of several books, including <I>Lethal Lolita</I>, <I>My Name Is Katherine</I>, <I>Sins of the Mother</I> and <I>Garden of Graves.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6560961c